import React from "react";
import {
  GommoneIcon,
  RibIcon,
  TenderIcon,
  OpenIcon,
  FishingIcon,
  FlybridgeIcon,
  SportIcon,
  CatamaranIcon,
  VelaIcon,
  YachtIcon,
} from "./Icons";

export interface BoatTypeInfo {
  code: string;
  nome: string;
  icona: React.ReactNode;
  colore: string;
  coloreTesto: string;
}

export const BOAT_TYPES: BoatTypeInfo[] = [
  {
    code: "GOM",
    nome: "Gommone",
    icona: <GommoneIcon />,
    colore: "bg-blue-100",
    coloreTesto: "text-blue-700",
  },
  {
    code: "RIB",
    nome: "RIB",
    icona: <RibIcon />,
    colore: "bg-cyan-100",
    coloreTesto: "text-cyan-700",
  },
  {
    code: "TEN",
    nome: "Tender",
    icona: <TenderIcon />,
    colore: "bg-amber-100",
    coloreTesto: "text-amber-700",
  },
  {
    code: "OPN",
    nome: "Open",
    icona: <OpenIcon />,
    colore: "bg-emerald-100",
    coloreTesto: "text-emerald-700",
  },
  {
    code: "CC",
    nome: "Center Console",
    icona: <FishingIcon />,
    colore: "bg-red-100",
    coloreTesto: "text-red-700",
  },
  {
    code: "WLK",
    nome: "Walkaround",
    icona: <OpenIcon />,
    colore: "bg-purple-100",
    coloreTesto: "text-purple-700",
  },
  {
    code: "FLY",
    nome: "Flybridge",
    icona: <FlybridgeIcon />,
    colore: "bg-indigo-100",
    coloreTesto: "text-indigo-700",
  },
  {
    code: "SPT",
    nome: "Sport",
    icona: <SportIcon />,
    colore: "bg-orange-100",
    coloreTesto: "text-orange-700",
  },
  {
    code: "FSH",
    nome: "Fishing",
    icona: <FishingIcon />,
    colore: "bg-teal-100",
    coloreTesto: "text-teal-700",
  },
  {
    code: "CAT",
    nome: "Catamarano",
    icona: <CatamaranIcon />,
    colore: "bg-pink-100",
    coloreTesto: "text-pink-700",
  },
  {
    code: "MON",
    nome: "Vela",
    icona: <VelaIcon />,
    colore: "bg-sky-100",
    coloreTesto: "text-sky-700",
  },
  {
    code: "MYT",
    nome: "Yacht",
    icona: <YachtIcon />,
    colore: "bg-yellow-100",
    coloreTesto: "text-yellow-700",
  },
];

interface BoatTypeBadgeProps {
  code: string;
  selected?: boolean;
  onClick?: () => void;
  size?: "sm" | "md" | "lg";
}

export function BoatTypeBadge({
  code,
  selected,
  onClick,
  size = "md",
}: BoatTypeBadgeProps) {
  const type = BOAT_TYPES.find((t) => t.code === code);
  if (!type) return null;

  const sizeClasses = {
    sm: "p-2 text-xs",
    md: "p-3 text-sm",
    lg: "p-4 text-base",
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        ${sizeClasses[size]} 
        rounded-lg border-2 transition-all duration-200
        flex flex-col items-center gap-1
        ${
          selected
            ? `${type.colore} border-current ${type.coloreTesto} scale-105 shadow-md`
            : "bg-white border-gray-200 text-gray-600 hover:border-gray-300 hover:bg-gray-50"
        }
      `}
    >
      <div
        className={
          size === "sm" ? "w-6 h-6" : size === "lg" ? "w-12 h-12" : "w-8 h-8"
        }
      >
        {type.icona}
      </div>
      <span className="font-medium">{type.nome}</span>
    </button>
  );
}

export function getBoatTypeInfo(code: string): BoatTypeInfo | undefined {
  return BOAT_TYPES.find((t) => t.code === code);
}